import type { WorkspacePersona } from "@/config/workspacePersona";

/** Shown under the “My Coach” page title. */
export const myCoachPageSubtitle =
  "Your confidential Socratic coaching space designed to help you explore challenges from multiple perspectives, uncover assumptions you may not have noticed, and arrive at your own insights and solutions.";

const COACHING_INITIAL_BY_PERSONA: Record<WorkspacePersona, string> = {
  leader:
    "Welcome to your private coaching space. I'm here as your confidential thinking partner — to help you navigate leadership challenges, staff dynamics, and the decisions only you can make. What's on your mind today?",
  district_leader:
    "Welcome to your private coaching space. I'm here as your confidential thinking partner — to help you think through district-level challenges, cross-team pressure, and the calls that sit with you. What's on your mind today?",
  teacher:
    "Welcome to your private coaching space. I'm here as your confidential thinking partner — to help you navigate challenges, rehearse conversations, and think through decisions. What's on your mind today?",
  support_staff:
    "Welcome to your private coaching space. I'm here as your confidential thinking partner — to help you navigate the student and staff support work you carry, rehearse tough conversations, and find your footing. What's on your mind today?",
  classified_staff:
    "Welcome to your private coaching space. I'm here as your confidential thinking partner — to help you navigate the operational and people challenges that keep your school running, and think through what's weighing on you. What's on your mind today?",
};

/** First assistant message in the My Coach thread when there is no history yet. */
export const getCoachingInitialAssistantMessage = (persona: WorkspacePersona = "teacher"): string =>
  COACHING_INITIAL_BY_PERSONA[persona];
